import { propagationContextFromHeaders } from "@sentry/core";
import getSentryConfig from "./config";
import patchFetchForSentryTrace from "./traceFetch";

function debugLog(...msgArr) {
  if (window.LOCAL_DEV) {
	console.debug(...msgArr);
  }
}

window.sentryState = window.sentryState || {};

export default function instrumentSentry(Sentry, namespace) {
  const isProd = window.ENVIRONMENT == "production";
  const validRelease = /^[\d\.]+$/.test(window.SITE_SENTRY_RELEASE || "");
  // When viewed through Google Translate's proxy the page is served from
  // *.translate.goog, which rewrites window.location.origin and defeats our
  // cross-origin / allowUrls / dropUrls filters. Skip Sentry entirely there.
  const isGoogleTranslateProxy = /(^|\.)translate\.goog$/i.test(window.location.hostname);

  if (window.sentryState[namespace]) {
	debugLog(`Reusing already configured Sentry for ${namespace}`, Sentry);
  } else if (window.SENTRY_DSN && !isGoogleTranslateProxy && (!isProd || validRelease)) {
	const config = window.sentryState.config || getSentryConfig(Sentry);
	if (!Sentry.getClient()) {
	  Sentry.init(config);
	  Sentry.getCurrentScope().setPropagationContext(
		propagationContextFromHeaders(window.SENTRY_TRACE, window.SENTRY_BAGAGGE)
	  );
	  patchFetchForSentryTrace(Sentry);
	  debugLog("Initialized Sentry with", config, Sentry);
	  window.sentryState["config"] = config;
	}
	window.sentryState[namespace] = true;
  } else if (!window.LOCAL_DEV) {
	console.warn("Sentry error logging disabled");
  }
}
